export default {"src":"/_next/static/media/hero_left.db56cbbe.svg","height":99,"width":34,"blurWidth":0,"blurHeight":0};